window.addEventListener("load", function () {
  window.swiper = new Swiper(".main-swiper", {
    direction: "vertical",
    slidesPerView: "auto",
    preloadImages: false,
    mousewheel: true,
    allowTouchMove: true,
    lazy: {
      loadPrevNext: true,
      loadOnTransitionStart: true,
    },
    on: {
      slideChange: function () {
        var $navItems = $(".group__right--item[data-slide]");
        $navItems.removeClass("active");
        $navItems
          .filter('[data-slide="' + window.swiper.activeIndex + '"]')
          .addClass("active");
      },
    },
  });
});

// Lắng nghe message từ iframe để điều khiển swiper
window.addEventListener("message", function (event) {
  if (event.data && event.data.type === "iframe-scroll") {
    if (!window.swiper) return; // Chờ swiper được khởi tạo

    if (event.data.direction === "down") {
      window.swiper.slideNext();
    } else if (event.data.direction === "up") {
      window.swiper.slidePrev();
    }
  }
});
